import React, { FC } from 'react'
import { sanitizeHTML } from '../../../../../utils/common-utils'
import { BrandIcon } from '../../../../Compounds/src/BrandIconCompound'
import { OneColumnBannerProps } from './OneColumnBanner.types'
import { getBgThemeBasedOnColor, getValueListBgColor } from '../../../../../utils/background-util'
import { LinkCompound } from '../../../../Compounds/src/LinkCompound'

export const OneColumnBanner: FC<OneColumnBannerProps> = props => {
  const { content } = props

  const {
    contentDesc,
    bgImage,
    bgColor,
    link,
    textAlignment,
    textColumnSize,
    icon,
    verticalSpacing,
    brandExtension,
    oneColumnId,
  } = content

  const hasFacet = bgColor?.includes('facet')
  const facet = hasFacet ? `url(${bgColor})` : ''

  const theme = getBgThemeBasedOnColor(bgColor as string)

  let iconsColorsDropdownValue = 'u-fillColorDarkMint'
  if (icon?.iconsColorsDropdown) {
    iconsColorsDropdownValue = icon.iconsColorsDropdown
  } else if (theme === 'Dark') {
    iconsColorsDropdownValue = 'u-fillColorMint'
  }

  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
      [id="${oneColumnId}"] .OneColBgdImage { background: ${
            bgImage ? `url("${bgImage}")` : facet
          }; }
      `,
        }}
      />

      <div className={`one-column-layout ${brandExtension}`}>
        <section
          className={`OneColBgdImage u-flex u-flexCol u-sizeFill u-flexJustifyCenter ${verticalSpacing} ${
            !hasFacet && getValueListBgColor(bgColor as string)
          } ${bgImage ? 'Banner--primary u-bgSizeCover' : 'Banner--secondary u-bgSizeCover'}`}
        >
          <div className='u-sizeConstrained'>
            <div
              className={`Content ${
                textColumnSize ? textColumnSize + ' u-marginCenter u-paddingVert80' : 'u-padding80'
              }`}
            >
              <div
                className={`u-sm-paddingHoriz16 u-padding20 Content ${textAlignment} ${
                  bgColor && theme === 'Dark' ? 'Content--reversed' : ''
                }`}
              >
                <div className={`${textAlignment} Content`}>
                  {icon && (
                    <BrandIcon
                      iconsDropdown={icon.iconsDropdown}
                      iconsColorsDropdown={iconsColorsDropdownValue}
                      alignment={icon.alignment?.length ? icon.alignment : 'center'}
                      size={icon.size}
                      identifier={icon.identifier}
                      stylesDropdown={icon.stylesDropdown}
                    />
                  )}
                  <div
                    className='u-marginBottom20'
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(contentDesc ?? ''),
                    }}
                  ></div>
                  {link?.map((currLink, index) => {
                    if (index < 2) {
                      return (
                        <LinkCompound
                          key={currLink.text}
                          {...currLink}
                          classes='u-marginHoriz8 u-sm-marginHoriz0 u-sm-block u-marginTop20'
                        />
                      )
                    }
                    return <></>
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
